import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

declare const $: any;
declare const swal: any;
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  translate = inject(TranslateService);

  delete = 'delete';
  undo = 'undo';

  constructor() {
    this.translate.get(['Delete', 'Undo']).subscribe((response) => {
      this.undo = response['Undo'];
      this.delete = response['Delete'];
    });
  }

  showDeleteDialog(question: string, callback: () => any) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal(
      {
        title: question,
        text: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#F7A600',
        confirmButtonText: this.delete,
        cancelButtonText: this.undo,
        closeOnConfirm: true,
      },
      function () {
        callback();
      }
    );
  }
  showQuestionDialog(question: string, text: string, callback: () => any) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal(
      {
        title: question,
        text: '',
        showCancelButton: true,
        confirmButtonColor: '#F7A600',
        confirmButtonText: text,
        cancelButtonText: this.undo,
        closeOnConfirm: true,
      },
      function () {
        callback();
      }
    );
  }

  showQuestionDialogTwoOptions(question: string, text: string, callback: () => any, callback2: () => any) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal(
      {
        title: question,
        text: '',
        showCancelButton: true,
        confirmButtonColor: '#F7A600',
        confirmButtonText: text,
        cancelButtonText: this.undo,
        closeOnConfirm: true,
      },
      function (inputValue) {
        if (inputValue) {
          callback();
        } else {
          callback2();
        }
      }
    );
  }

  showQuestionDialogTwoOptionsTwoTexts(
    question: string,
    text1: string,
    text2: string,
    callback: () => any,
    callback2: () => any
  ) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal(
      {
        title: question,
        text: '',
        showCancelButton: true,
        confirmButtonColor: '#F7A600',
        confirmButtonText: text1,
        cancelButtonText: text2,
        closeOnConfirm: true,
      },
      function (inputValue) {
        if (inputValue) {
          callback();
        } else {
          callback2();
        }
      }
    );
  }

  showIsSkippingOrCancelled(callback1: () => any, callback2: () => any) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal({
      text: 'Even three buttons, each with their own promise value!',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Click me!',
        hello: 'Say hello!',
      },
    });
  }

  showSuccessDialog(title: string) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal({
      title: title,
      timer: 3000,
      confirmButtonColor: '#F7A600',
      type: 'success',
    });
  }
  showDialog(title: string) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal({
      title: title,
      confirmButtonColor: '#F7A600',
    });
  }

  showInfoDialog(question: string, text: string, callback: () => any) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    swal(
      {
        title: question,
        text: '',
        confirmButtonColor: '#F7A600',
        confirmButtonText: text,
        closeOnConfirm: true,
      },
      function () {
        callback();
      }
    );
  }

  showDebugErrorDialog(error: HttpErrorResponse) {
    this.delete = this.translate.instant('Delete');
    this.undo = this.translate.instant('Undo');
    let text = '';
    let fault = 'SERVER ERROR';
    try {
      text = error.error;
      if (text.length >= 900) {
        text = text.substring(0, 450) + '\r\n...\r\n' + text.substring(text.length - 450, text.length);
      } else {
        fault = error.error.fault;
        text = error.error.userMessage;
      }
    } catch {
      fault = error.error.fault;
      text = error.error.userMessage;
    }

    swal({
      title: fault,
      backgroundColor: '#FF0000',
      confirmButtonColor: '#FF0000',
      text: text,
      heightAuto: true,
    });
  }

  private setLanguageButtons() {}
}
